import {
  CardDefinition,
  CAROUSEL,
  CarouselDefinition,
  CAROUSEL_NEXT,
  LAYOUT_LIST
} from '../items';
import { Translator } from '../Translator';
import { CardHelper } from './itemHelpers/CardHelper';
import { ItemOfType } from './itemHelpers/types';
import { translate } from './translate';

export const Multimedia4: Translator = sequence => {
  const cards: CardDefinition[] = [];
  const cardCount =
    sequence.items?.filter(i => i.__typename === 'Card').length || 0;
  let cardIndex = 1;
  const root = translate(sequence, item => {
    if (item.__typename === 'Card') {
      cards.push(
        CardHelper(item as ItemOfType<'Card'>, {
          height: 'unset',
          minHeight: '500px',
          width: '368px',
          padding: 0,
          blocking: true,
          replay: false,
          align: 'left',
          extraItems:
            cardIndex === cardCount
              ? [
                  {
                    id: item.id,
                    type: LAYOUT_LIST,
                    values: {
                      align: 'center'
                    },
                    items: []
                  }
                ]
              : [
                  {
                    id: item.id,
                    type: LAYOUT_LIST,
                    values: {
                      align: 'center'
                    },
                    items: [
                      {
                        id: `${item.id}.next`,
                        type: CAROUSEL_NEXT,
                        values: { sequence },
                        items: []
                      }
                    ]
                  }
                ]
        })
      );

      cardIndex++;
    }

    return null;
  });

  root.items.push({
    type: CAROUSEL,
    id: `${sequence.id}.carousel`,
    values: {
      variant: 'horizontal'
    },
    items: cards
  } as CarouselDefinition);

  return root;
};
